import { getField, updateField } from 'vuex-map-fields'
import getInvoicingReportFilters from './models/invoicingReportFilters'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { ALL_BUSINESS_ENTITIES } from '@/lib/constants/businessEntities'

const invoicingReportFilters = {
  namespaced: true,
  state: buildInitialState({
    ...getInvoicingReportFilters()
  }),
  getters: {
    getField,
    getSearchObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    updateStatus,
    clearFilters: (state) => {
      state.invoiceFrequencyId = null
      state.dateBegin = null
      state.dateEnd = null
      state.businessEntityId = ALL_BUSINESS_ENTITIES
      state.clientId = null
      state.showDetails = false
    }
  },
  actions: {
    clearInvoicingReportFilters: ({ commit }) => {
      return commit('clearFilters')
    }
  }
}

export default invoicingReportFilters
